module.exports = __webpack_public_path__ + "2dbdeb92c8942fd0549b027290ba08ae.png";